module.exports = __webpack_public_path__ + "img/ZI.2282be62.png";